import React, { useState, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import AuthContext from "context/AuthContext";
import Interview from "./Interview";
import TemplateManager from "./TemplateManager";

const tabBtnClass = "inline-block py-3 px-8 text-md xl:text-lg font-semibold border-b-2";
const tabActiveClass = "border-blue-600 text-blue-600";
const tabBorderNoneClass = "border-transparent";
const TAB_INTERVIEW = "interview"; // CHANGED — was TAB_REQUEST / TAB_LISTING (now merged)
const TAB_TEMPLATES = "templates";

const InterviewManager = () => {
  const { t } = useTranslation();
  const { updatePageName, user } = useContext(AuthContext);
  const [defaultTab, setDefaultTab] = useState(TAB_INTERVIEW);
  const handleTabClick = (action, e) => {
    setDefaultTab(action);
  };

  useEffect(() => {
    updatePageName(t("INTERVIEW_MANAGER"));
  }, []);

  return (
    <div className="">
      <div className="py-3 my-2">
        <ul className="border-b flex">
          <li className="mr-0 xl:mr-5">
            <button
              onClick={handleTabClick.bind(this, TAB_INTERVIEW)}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]: defaultTab === TAB_INTERVIEW,
                [tabBorderNoneClass]: defaultTab !== TAB_INTERVIEW,
              })}
            >
              {t("INTERVIEW") || "Interview"}
            </button>
          </li>
          <li className="mx-0 xl:mx-5">
            <button
              onClick={handleTabClick.bind(this, TAB_TEMPLATES)}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]: defaultTab === TAB_TEMPLATES,
                [tabBorderNoneClass]: defaultTab !== TAB_TEMPLATES,
              })}
            >
              {t("INTERVIEW_TEMPLATES") || "Interview Templates"}
            </button>
          </li>
        </ul>
      </div>

      {defaultTab === TAB_INTERVIEW && <Interview />}
      {defaultTab === TAB_TEMPLATES && <TemplateManager />}
    </div>
  );
};

export default InterviewManager;